import FormTitle from '@core/components/FormTitle';
import { CurrencyTextField, DateInput, ReadOnlyInput } from '@core/components/Inputs';
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Tooltip,
} from '@material-ui/core';
import { SelectCategoria, SelectServico } from 'app/components/Select';
import { calcularValorLiquidoComRetencoes } from 'app/main/venda/utils/retencaoLiquidoUtils';
import { calcularValorComDesconto, getCurrency } from 'app/utils/monetarioUtil';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { MdSettings } from 'react-icons/md';
import RetencaoAliquotaModal from '../../../../servico/components/modal/Retencoes/RetencaoAliquotaModal';

const AdesaoContrato = ({
  values,
  handleChange,
  handleBlur,
  handleChangeServico,
  errors,
  isContratoCobrancaBaixadaOuRemessaGerada,
}) => {
  const formikContext = useFormikContext();
  const [indexServicoSelecionado, setIndexServicoSelecionado] = useState(0);
  const [modalRetencaoAliquota, setModalRetencaoAliquota] = useState('');

  const valuesServico = values?.servico;
  const valuesServicoFiscal = values?.servicoFiscal;
  const valuesValor = values?.valor;
  useEffect(() => {
    calcularValorTotal();
    // Efeito reativo apenas ao gatilho listado; incluir as demais dependências alteraria
    // quando o efeito dispara.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valuesServico, valuesServicoFiscal, valuesValor]);

  const isRetido =
    values?.servicoFiscal?.issRetidoNaFonte ||
    values?.servicoFiscal?.pisRetidoNaFonte ||
    values?.servicoFiscal?.cofinsRetidoNaFonte ||
    values?.servicoFiscal?.inssRetidoNaFonte ||
    values?.servicoFiscal?.irrfRetidoNaFonte ||
    values?.servicoFiscal?.csllRetidoNaFonte;

  const getSubTotalAdesao = () => calcularValorLiquidoComRetencoes(values?.valor || 0, values?.servicoFiscal);

  const calcularValorTotal = () => {
    let total = getSubTotalAdesao();
    formikContext.setFieldValue('adesao.subtotal', total);
  };

  // RNE-517
  const disabledToggle =
    values?.isCobrancaBaixadaOuRemessaGerada ||
    (!values?.cobrarAdesao && !values.id && isContratoCobrancaBaixadaOuRemessaGerada);

  useEffect(() => {
    const dataInicioPromocao = values.servico?.promocao?.vigenciaInicio;
    const dataFimPromocao = values.servico?.promocao?.vigenciaFim;

    const dataVigenciaInicial =
      formikContext.values.dataVigenciaInicial !== undefined &&
      moment(formikContext.values.dataVigenciaInicial).format('YYYY-MM-DD');

    if (dataVigenciaInicial >= dataInicioPromocao && dataVigenciaInicial <= dataFimPromocao) {
      var valorPromocional = null;
      const tipo = values.servico?.promocao?.tipo;

      if (tipo === 'PERCENTUAL') {
        valorPromocional = calcularValorComDesconto(
          'PERCENTUAL',
          values.servico?.valorVenda,
          values.servico?.promocao?.valor
        );
      } else {
        valorPromocional = calcularValorComDesconto(
          'VALOR',
          values.servico?.valorVenda,
          values.servico?.promocao?.valor
        );
      }
      formikContext.setFieldValue('adesao.valor', valorPromocional);
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikContext.values.dataVigenciaInicial, values.servico]);

  const handlerSubmitRetencaoAliquota = (servicoFiscal) => {
    const isUtilizadoIbsCbs =
      servicoFiscal?.cstSituacaoTributaria?.id ||
      servicoFiscal?.cstClassificacaoTributaria?.id ||
      servicoFiscal?.valorIbs > 0 ||
      servicoFiscal?.valorIbsMunicipal > 0 ||
      servicoFiscal?.valorCbs > 0 ||
      servicoFiscal?.valorIs > 0;

    servicoFiscal.possuiIbsCbs = !!isUtilizadoIbsCbs;

    const servicoFiscalAtualizado = values.servicoFiscal?.id
      ? { ...servicoFiscal, id: values.servicoFiscal.id }
      : { ...servicoFiscal, id: null };

    formikContext.setFieldValue('adesao.servicoFiscal', servicoFiscalAtualizado);
    setModalRetencaoAliquota('');
  };

  const handlerRetencaoAliquota = (index) => {
    setIndexServicoSelecionado(index);
    setModalRetencaoAliquota('retencaoAliquota');
  };

  return (
    <>
      <FormTitle title="Adesão" />
      <Grid container spacing={3} className="mt-16 mb-16">
        <Grid item xs={12}>
          <FormControlLabel
            label="Cobrar adesão"
            control={
              <Switch
                id="adesao.cobrarAdesao"
                name="adesao.cobrarAdesao"
                value={values?.cobrarAdesao}
                checked={values?.cobrarAdesao}
                onChange={handleChange}
                onBlur={handleBlur}
                size="small"
                color="primary"
                disabled={disabledToggle}
              />
            }
          />
        </Grid>

        {/* RNE-526 */}
        {values?.cobrarAdesao && (
          <>
            <Grid item xs={!values?.servico ? 12 : 11}>
              <SelectServico
                id="adesao.servico"
                name="adesao.servico"
                label="Serviço"
                onChange={(e, index) => {
                  handleChangeServico(e, index);

                  formikContext.setFieldValue('adesao.valor', e.target.value?.valorVenda);
                  formikContext.setFieldValue('adesao.subtotal', e.target.value?.valorVenda);
                }}
                onBlur={handleBlur}
                value={values?.servico}
                required
                error={errors.servico}
                touched={!!errors.servico}
                disabled={values?.isCobrancaBaixadaOuRemessaGerada}
              />
            </Grid>

            {values?.servico && (
              <Tooltip title="Atualizar alíquotas" placement="right-end">
                <IconButton onClick={() => handlerRetencaoAliquota(indexServicoSelecionado)}>
                  <MdSettings size={18} />
                </IconButton>
              </Tooltip>
            )}

            {indexServicoSelecionado !== undefined && (
              <RetencaoAliquotaModal
                modalRetencaoAliquota={modalRetencaoAliquota}
                setModalRetencaoAliquota={setModalRetencaoAliquota}
                itemServico={values}
                onSubmit={handlerSubmitRetencaoAliquota}
                nome={values?.servico?.descricao}
                codigo={values?.servico?.codigo}
                descricaoDetalhada={values?.servico?.descricaoDetalhada}
              />
            )}

            <Grid item xs={12}>
              <SelectCategoria
                id="adesao.categoria"
                label="Categoria"
                value={values?.categoria}
                onChange={handleChange}
                onBlur={handleBlur}
                maxLength={100}
                natureza="RECEITA"
                required
                error={errors.categoria}
                touched={!!errors.categoria}
                disabled={values?.isCobrancaBaixadaOuRemessaGerada}
              />
            </Grid>
            <Grid item xs={10}>
              <CurrencyTextField
                id="adesao.valor"
                name="adesao.valor"
                value={values?.valor}
                outputFormat="number"
                decimalCharacter=","
                digitGroupSeparator="."
                maximumValue="999999999"
                minimumValue="0"
                decimalPlaces={2}
                decimalPlacesShownOnBlur={2}
                decimalPlacesShownOnFocus={2}
                onChange={(e, value) => {
                  const event = {
                    target: {
                      id: e.target.id,
                      value: e.target.value === '' ? '' : value,
                    },
                  };
                  handleChange(event);
                }}
                onBlur={handleBlur}
                fullWidth
                variant="outlined"
                label="Valor (R$)"
                required
                error={errors.valor}
                helperText={errors.valor}
                touched={!!errors.valor}
                disabled={values?.isCobrancaBaixadaOuRemessaGerada}
                currencySymbol=""
              />
            </Grid>
            <Grid item xs={2}>
              {isRetido ? (
                <Tooltip title="Valor final considerando as retenções do serviço pelo cliente" placement="bottom-end">
                  <div>
                    <ReadOnlyInput
                      id="adesao.subtotal"
                      label="Subtotal (R$)"
                      value={getSubTotalAdesao() > 0 ? getCurrency(getSubTotalAdesao()) : '-'}
                    />
                  </div>
                </Tooltip>
              ) : (
                <div>
                  <ReadOnlyInput
                    id="adesao.subtotal"
                    label="Subtotal (R$)"
                    value={getSubTotalAdesao() > 0 ? getCurrency(getSubTotalAdesao()) : '-'}
                  />
                </div>
              )}
            </Grid>
            <Grid item xs={6}>
              <FormControl variant="outlined" style={{ width: '100%' }}>
                <InputLabel id="adesao.formaCobranca" required shrink>
                  Forma de recebimento
                </InputLabel>
                <Select
                  id="adesao.formaCobranca"
                  name="adesao.formaCobranca"
                  label="Forma de recebimento *"
                  labelId="adesao.formaCobranca"
                  value={values?.formaCobranca}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  error={errors.formaCobranca}
                  helperText={errors.formaCobranca}
                  touched={!!errors.formaCobranca}
                  disabled={values?.isCobrancaBaixadaOuRemessaGerada}
                  notched
                >
                  <MenuItem value="BOLETO">Boleto</MenuItem>
                  <MenuItem value="PIX">PIX</MenuItem>
                  <MenuItem value="CARTAO_DEBITO">Cartão de débito</MenuItem>
                  <MenuItem value="CARTAO_CREDITO">Cartão de crédito</MenuItem>
                  <MenuItem value="DINHEIRO">Dinheiro</MenuItem>
                  <MenuItem value="TED_DOC">TED/DOC</MenuItem>
                  <MenuItem value="CHEQUE">Cheque</MenuItem>
                </Select>
                <FormHelperText style={{ color: '#f44336' }}>{errors.formaCobranca || ''}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <DateInput
                id="adesao.dataVencimento"
                name="adesao.dataVencimento"
                label="Data do vencimento"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values?.dataVencimento}
                error={errors.dataVencimento}
                helperText={errors.dataVencimento}
                touched={!!errors.dataVencimento}
                required
                fullWidth
                variant="outlined"
                disabled={values?.isCobrancaBaixadaOuRemessaGerada}
              />
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

export default AdesaoContrato;
